
if ( window.innerWidth < 600 ) {
    const tables = document.querySelectorAll('.c-flex-text table, .c-flex-text-props table');
    tables.forEach(function (table) {
        const tableWrapper = document.createElement('div');
        tableWrapper.classList.add('table-wrapper');

        // Wrap the table with the div
        table.parentNode.insertBefore(tableWrapper, table);
        tableWrapper.appendChild(table);

        // Check if the width is more than 500px and add a class accordingly
        const tableWidth = table.getAttribute('width');
        if (tableWidth > 600) {
            table.classList.add('wide-table');
        }
    });
}
